enum BaseRoles {
  SuperAdmin = "SUPER_ADMIN",
  Admin = "ADMIN",
  Manager = "MANAGER",
  User = "USER",
  SuperDuperAdmin = "SUPER_DUPER_ADMIN",
}

const Roles = {
  ...BaseRoles,

  AdminsAndManager: [
    BaseRoles.Manager,
    BaseRoles.Admin,
    BaseRoles.SuperAdmin,
    BaseRoles.SuperDuperAdmin,
  ],

  Admins: [BaseRoles.Admin, BaseRoles.SuperAdmin, BaseRoles.SuperDuperAdmin],

  SuperAdmins: [BaseRoles.SuperAdmin, BaseRoles.SuperDuperAdmin],

  OrganizationManagers: [
    BaseRoles.Manager,
    BaseRoles.Admin,
    BaseRoles.SuperAdmin,
  ],

  All: Object.values(BaseRoles),
};

enum OrganizationRoles {
  Volunteer = "VOLUNTEER",
  Requesting = "REQUESTING",
  InGroup = "IN_GROUP",
  InTeam = "IN_TEAM",
  InOpportunity = "IN_OPPORTUNITY",
  /** מנהל ארגון שותף באפליקציה */
  Organization = "ORGANIZATION",
}

export { BaseRoles, OrganizationRoles, Roles };
